import React from "react";
import Api from "../../../Services/Api";

export const getTableColumns = (isMutasiKeluar, pagination) => {
  const baseColumns = [
    {
      name: "id",
      label: "No",
      options: {
        customBodyRender: (_, tableMeta) => {
          const page = pagination.page - 1;
          const limit = pagination.limit;

          const rowNumber = page * limit + tableMeta.rowIndex + 1;
          return <>{rowNumber}</>;
        },
        sort: false,
      },
    },
    { name: "mutationNumber", label: "No. Mutasi" },
    { name: "date", label: "Tanggal Mutasi" },
    { name: "sourceCabang", label: "Asal" },
    { name: "sourceLocator", label: "Locator Asal" },
    { name: "targetCabang", label: "Tujuan" },
    { name: "targetLocator", label: "Locator Tujuan" },
    { name: "qty", label: "Qty" },
    { name: isMutasiKeluar? "status" : "receivedStatus", label: "Status" },
  ];

  if (isMutasiKeluar) {
    baseColumns.push({
      name: "receivedStatus",
      label: "Status Penerimaan",
    });
  }

  return baseColumns;
};

export const TABS = {
  mutasiKeluar: {
    name: "mutasiKeluar",
    getAll: (body) =>
      Api.create("NAGAMAS_TRANSACTION").getAllMutationPart(body),
    getById: (id) => Api.create("NAGAMAS_TRANSACTION").getMutationPartById(id),
    delete: (id) => Api.create("NAGAMAS_TRANSACTION").deleteMutationPart(id),
    create: (body) =>
      Api.create("NAGAMAS_TRANSACTION").submitDataMutationPart(body),
    update: (body) =>
      Api.create("NAGAMAS_TRANSACTION").submitDataMutationPart(body),
  },
  mutasiMasuk: {
    name: "mutasiMasuk",
    getAll: (body) =>
      Api.create("NAGAMAS_TRANSACTION").getAllMutationPart(body),
    getById: (id) => Api.create("NAGAMAS_TRANSACTION").getMutationPartById(id),
    delete: (id) => Api.create("NAGAMAS_TRANSACTION").deleteMutationPart(id),
    create: (body) =>
      Api.create("NAGAMAS_TRANSACTION").processMutationPart(body),
    update: (body) =>
      Api.create("NAGAMAS_TRANSACTION").processMutationPart(body),
  },
};
